import { useMemo, useState } from 'react'

// components
import ModalEdit from './modalEdit/ModalEdit'

// mui
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'
import DriveFileRenameOutlineOutlinedIcon from '@mui/icons-material/DriveFileRenameOutlineOutlined'

const isForbiddenCentroName = name =>
  (name || '').trim().toLowerCase() === 'estado de resultados consolidado'.toLowerCase()

const ListCentroCostos = ({ centroCostos, onDelete, onRefresh }) => {
  const [nombreFilter, setNombreFilter] = useState('')
  const [open, setOpen] = useState(false)
  const [selectedCentroId, setSelectedCentroId] = useState(null)

  const filteredData = useMemo(() => {
    // 1) Primero filtro el centro que NO quiero mostrar nunca
    const base = (centroCostos || []).filter(item => !isForbiddenCentroName(item.name))

    // 2) Luego aplico el filtro por nombre (buscador)
    const term = nombreFilter.trim().toLowerCase()
    if (!term) return base

    return base.filter(item => (item.name || '').toLowerCase().includes(term))
  }, [centroCostos, nombreFilter])

  if (!centroCostos || centroCostos.length === 0) {
    return (
      <div className='mt-4'>
        <div className='flex items-center mb-2'>
          <h2 className='font-semibold text-lg'>Centros de Costos</h2>
        </div>
        <p className='text-gray-500 mt-4'>No hay centros de costos creados aún.</p>
      </div>
    )
  }

  const handleClose = () => {
    setSelectedCentroId(null)
    setOpen(false)
  }

  const handleOpenEdit = item => {
    const id = item.id || item._id
    setSelectedCentroId(id)
    setOpen(true)
  }

  return (
    <div className='mt-4'>
      {/* Título + filtro */}
      <div className='flex items-center mb-2'>
        <h2 className='font-semibold text-lg'>Centros de Costos</h2>
      </div>

      <div className='flex flex-wrap gap-6 items-end border border-gray-200 rounded-md p-4 bg-gray-50 mb-3'>
        <div className='flex flex-col'>
          <input
            type='text'
            value={nombreFilter}
            onChange={e => setNombreFilter(e.target.value)}
            placeholder='Buscar por nombre'
            className='min-w-[200px] border border-gray-300 rounded-full px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400'
          />
        </div>
      </div>

      {/* Tabla */}
      <div className='border border-gray-200 rounded-md overflow-hidden'>
        <table className='min-w-full text-sm'>
          <thead className='bg-gray-100'>
            <tr>
              <th className='px-4 py-2 text-left font-semibold'>Nombre</th>
              <th className='px-4 py-2 text-center font-semibold w-24'>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.length === 0 ? (
              <tr>
                <td colSpan={2} className='px-4 py-3 text-center text-gray-500'>
                  No se encontraron centros de costos con ese nombre.
                </td>
              </tr>
            ) : (
              filteredData.map(item => (
                <tr key={item.id || item._id} className='border-t hover:bg-gray-50'>
                  <td className='px-4 py-2'>{item.name}</td>
                  <td className='px-4 py-2 text-center space-x-2'>
                    <button
                      type='button'
                      onClick={() => onDelete(item.id || item._id)}
                      className='text-red-600 hover:text-red-800 transition'
                      title='Eliminar centro de costos'
                    >
                      <DeleteOutlineOutlinedIcon fontSize='small' />
                    </button>
                    <button
                      type='button'
                      onClick={() => handleOpenEdit(item)}
                      className='text-gray-500 hover:text-gray-800 transition'
                      title='Editar centro de costos'
                    >
                      <DriveFileRenameOutlineOutlinedIcon fontSize='small' />
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {open && (
        <ModalEdit
          open={open}
          handleClose={handleClose}
          centroCostoId={selectedCentroId}
          onSuccess={onRefresh}
        />
      )}
    </div>
  )
}

export default ListCentroCostos
